/**
 * @ComponentFor Avensia.Shop.Features.Cms.Pages.Cms.CmsPageViewModel
 */
import React, { useEffect } from "react";
import connect from "Shared/connect";
import { epiPropertyValue, EpiProperty } from "@avensia/nitro5-scope-episerver";
import Main, { Section, Part } from "Shared/PageLayout";
import * as styles from "./base.scss";
import * as pageLayoutStyles from "Shared/PageLayout/base.scss";
import { translate } from "Shared/translate";
import * as propertForStyles from "Shared/propertyFor.scss";
function CmsPage(props) {
    useEffect(() => {
        var _a;
        const cookieProp = document.querySelector(".optanon-show-settings");
        const hasLoaded = localStorage.getItem("loaded");
        if (cookieProp) {
            if (hasLoaded === null || hasLoaded === "false") {
                localStorage.setItem("loaded", "true");
                return location.reload();
            }
            else {
                localStorage.setItem("loaded", "false");
            }
        }
        if ((_a = props.meta) === null || _a === void 0 ? void 0 : _a.title) {
            sessionStorage.setItem('ga4ItemListReferrel', props.meta.title);
        }
    }, []);
    return (React.createElement(Main, { appearance: "narrow" },
        React.createElement(Section, null,
            React.createElement(EpiProperty, { component: "h1", for: props.page.name }),
            !!epiPropertyValue(props.page.hero) && (React.createElement("div", { className: styles.hero },
                React.createElement("img", { src: epiPropertyValue(props.page.hero).url, alt: epiPropertyValue(props.page.name) }))),
            !!epiPropertyValue(props.page.isCookies) && (React.createElement("span", null,
                React.createElement("div", { className: styles.text },
                    React.createElement("span", null, translate("/Footer/CookieDescription")),
                    React.createElement("a", { className: "optanon-show-settings" }, translate("/Footer/CookieSettings"))),
                React.createElement("div", null,
                    React.createElement("br", null),
                    React.createElement("div", { id: "ot-sdk-cookie-policy" }))))),
        React.createElement(Section, { layout: !!epiPropertyValue(props.page.showSideMenu) ? "3to1" : null },
            React.createElement(Part, null,
                React.createElement("h3", { className: styles.pageName }, typeof props.page.preamble == "string" ? props.page.preamble : epiPropertyValue(props.page.preamble)),
                React.createElement(EpiProperty, { for: props.page.mainBody, className: propertForStyles.textBase }),
                React.createElement(EpiProperty, { for: props.page.mainContent, className: propertForStyles.base })),
            !!epiPropertyValue(props.page.showSideMenu) && (React.createElement(Part, { className: pageLayoutStyles.sidebar },
                React.createElement(EpiProperty, { for: props.page.sideBarBody, className: propertForStyles.textBase }),
                React.createElement(EpiProperty, { for: props.page.sideBarContent, className: propertForStyles.base })))),
        React.createElement(Part, null)));
}
export default connect((state) => ({
    currentBreakpoint: state.currentBreakpoint,
}))(CmsPage);
